export const SHOW_TURNTABLE = 'SHOW_TURNTABLE_YNW'
export const SET_TURNTABLE_SIZE = 'SET_TURNTABLE_SIZE_YNW'
export const SET_RESULT_SELECTED = 'SET_RESULT_SELECTED_YNW'
export const SET_TITLE_OBJ = 'SET_TITLE_OBJ_YNW'
export const SET_MYSTERY_WHEEL_ON = 'SET_MYSTERY_WHEEL_ON_YNW'
export const SET_MYSTERY_RESULT_ON = 'SET_MYSTERY_RESULT_ON_YNW'
// export const SET_CHOICES = 'SET_CHOICES_RTW'
